import { render, staticRenderFns } from "./exportMarketing.vue?vue&type=template&id=5ff5e60f&"
import script from "./exportMarketing.vue?vue&type=script&lang=js&"
export * from "./exportMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports